import { Home , Anchor,  Airplay, BatteryCharging, Box,  GitBranch,  DollarSign, FolderPlus,Gift, Command, Cloud, BarChart, Users, ShoppingBag, Phone, List, Mail, MessageCircle, GitPullRequest, Monitor,Heart, Clock,Zap,CheckSquare, Calendar, Image,HelpCircle,Radio,Map,Edit, Sunrise,Package,Sliders,Layout,Server,Database,Search,File,Layers,UserCheck,Wifi, CreditCard, FileText} from "react-feather";

import { LuUsers2 } from "react-icons/lu";
import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import evtorlogo from "../../assets/images/evtorlogo.jpg"
// import evtorlogo from "../../../public/evtorlogo.png";

export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent:
      "Dashboards, Widgets, Enquire, Masters, Users, Stations, Chargers, Ocpp, RFID, Transactions",
    Items: [
      {
        // title: 'Dashboard', icon: Home, type: 'sub', active: false, children: [
        //     { path: `${process.env.PUBLIC_URL}/dashboard/default`, title: 'Default', type: 'link' },
        //     { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, title: 'Ecommerce', type: 'link' },
        // ]
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
        title: "Dashboard",
        icon: Home,
        type: "link",
      },
      // {
      //     title: 'Widgets', icon: Airplay, type: 'sub', active: false, children: [
      //         { path: `${process.env.PUBLIC_URL}/widgets/general`, title: 'General', type: 'link' },
      //         { path: `${process.env.PUBLIC_URL}/widgets/chart`, title: 'Chart', type: 'link' },
      //     ]
      // },
      // {
      //   path: `/enquire/enquire`,
      //   title: "Enquire",
      //   icon: Users,
      //   type: "link",
      //   // { path: `${process.env.PUBLIC_URL}/widgets/chart`, title: 'Chart', type: 'link' },
      // },
      {
        // title: 'Student', icon: Users, type: 'sub', active: false, children: [
        //     { path: `${process.env.PUBLIC_URL}/students/students`, title: 'Students', type: 'link' },
        //     // { path: `${process.env.PUBLIC_URL}/students/students`, title: 'Chart', type: 'link' },
        // //
        // ]

        title: "Masters",
        icon: Command,
        type: "sub",
        active: false,
        children: [
          {
            path: `/masters/filtercategorylist`,
            title: "Categories",
            icon: Users,
            type: "link",
          },
          {
            path: `/masters/deletedfiltercategorylist`,
            title: "Deleted Categories",
            icon: Users,
            type: "link",
          },
    
     
        ],

        
      },

      //user-management
      {
    

        title: "User Management",
        icon: LuUsers2,
        type: "sub",
        active: false,
        children: [
          {
            path: `/usermanagement/users`,
            title: "Users",
            icon: Users,
            type: "link",
          },
          {
            path: `/usermanagement/vendors`,
            title: "Vendors",
            icon: Users,
            type: "link",
          },
          {
            path: `/usermanagement/users/requestdeletedusers`,
            title: "Requested Deleted Users",
            icon: Users,
            type: "link",
          },
          {
            path: `/usermanagement/users/deletedusers`,
            title: "Deleted Users",
            icon: Users,
            type: "link",
          },
    ],

        
      },

      //stations


      {
        title: "Stations",
        icon: BsEvStation,
        type: "sub",
        active: false,
        children: [
          {
            path: `/stations`,
            title: "Stations",
            icon: Users,
            type: "link",
          },
          {
            path: `/charger-live-status`,
            title: "Charger Live Status",
            icon: Users,
            type: "link",
          },
      
          ///
          {
            path: `/deleted-stations`,
            title: "Deleted Stations",
            icon: Users,
            type: "link",
          },
          // {
          //   path: `/stations-upload-dummyImage`,
          //   title: "Upload Dummy Image",
          //   icon: Users,
          //   type: "link",
          // },
    
   /////
//   
        ],

        
      },

      ///usermanagement/users/deletedusers



      {
        title: "Chargers",
        icon: FaChargingStation,
        type: "sub",
        active: false,
        children: [
          {
            path: `/chargers`,
            title: "Chargers",
            icon: Users,
            type: "link",
          },
          {
            path: `/chargers/deletedchargers`,
            title: "Deleted Chargers",
            icon: Users,
            type: "link",
          },
          {
            path: `/connectors`,
            title: "Connectors",
            icon: Users,
            type: "link",
          },
          // {
          //   path: `/charger-upload-dummyImage`,
          //   title: "Upload Dummy Image",
          //   icon: Users,
          //   type: "link",
          // },
       
        ],

        
      },
//
      //rfid


      {
         title: "RFID Record",
        icon: Wifi,
        type: "sub",
        active: false,
        children: [
          {
            path: `/rfid-record/rfid-list`,
            title: "RFID List",
            icon: Users,
            type: "link",
          },
          // {
          //   path: `/rfid-record/rfid-offers`,
          //   title: "RFID Offers",
          //   icon: Users,
          //   type: "link",
          // },
          {
            path: `/rfid-record/qrcode-payment`,
            title: "QR Code Payment",
            icon: Users,
            type: "link",
          },
          {
            path: `/rfid-record/rfidoffer-add`,
            title: "Assign Station Offer",
            icon: Users,
            type: "link",
          },
       
        ],

        
      },


      //ocpp

 {
        title: "OCPP",
        icon: Airplay,
        type: "sub",
        active: false,
        children: [
          {
            path: `/ocpp/ocpp-logs`,
            title: "OCPP Logs",
            icon: Users,
            type: "link",
          },
          {
            path: `/ocpp-logs/liveping`,
            title: "Live Pings",
            icon: Users,
            type: "link",
          },
       
///

       
        ],

        
      },

      //evtor

      {
        title: "Evtor",
        icon: Airplay,
        type: "sub",
        active: false,
        children: [
          {
            path: `/evtor/evtorListing`,
            title: "Evtor Logs",
            icon: Users,
            type: "link",
          },
       
          {
            path: `/evtor-logs/livedata`,
            title: "Live Pings",
            icon: Users,
            type: "link",
          },
          {
            path: `/evtor-logs/kwpowerdifference`,
            title: "KW Power Difference",
            icon: Users,
            type: "link",
          },

       
        ],

        
      },
//Transactions
      {
        title: "Transactions",
        icon: GrTransaction,
        type: "sub",
        active: false,
        children: [
          {
            path: `/meter-record/meter-list`,
            title: "View Transactions",
            icon: Users,
            type: "link",
          },
          {
            path: `/meter-record/awaitingstartchargers`,
            title: "Awaiting Start Chargers",
            icon: Users,
            type: "link",
          },
       
       ],

        
      },



      //*********************statements*********************
      {
        title: "Statements",
        icon: GrTransaction,
        type: "sub",
        active: false,
        children: [
          {
            path: `/statements/statementListing`,
            title: "Statements",
            icon: Users,
            type: "link",
          },
 ],
},
//*********************Payments*********************
{
  title: "Payments",
  icon: DollarSign,
  type: "sub",
  active: false,
  children: [
    {
      path: `/payments`,
      title: "All Payments",
      icon: CreditCard,
      type: "link",
    },
    {
      path: `/qrcodepayments`,
      title: "QR Code payments",
      icon: CreditCard,
      type: "link",
    },
    {
      path: `/withdrawals`,
      title: "All withdrawals",
      icon: CreditCard,
      type: "link",
    },
//
  ]
},
     //*******************Reports****************************
{
  title: "Reports",
  icon: FileText,
  type: "sub",
  active: false,
  children: [

    {
      path: `/evtordataanalysis`,
      title: "Evtor Data Analysis",
      icon: CreditCard,
      type: "link",
    },
    {
      path: `/charts`,
      title: "Charts",
      icon: CreditCard,
      type: "link",
    },
    {
      path: `/report-excel`,
      title: "Report Excel",
      icon: CreditCard,
      type: "link",
    },
  ]
},
//*********************SMS Logs ************************* */
{
  title: "SMS Logs",
  icon: MessageCircle,
  type: "sub",
  active: false,
  children: [

    {
      path: `/sms-logs`,
      title: "SMS Logs",
      icon: MessageCircle,
      type: "link",
    },
  ]
},
//*********************Offers*********************
{
  title: "Offers",
  icon: Gift,
  type: "sub",
  active: false,
  children: [

    {
      path: `/offers/offer-list`,
      title: "Offers",
      icon: MessageCircle,
      type: "link",
    },
  ]
},
//*********************Versions*********************
{
  title: "Versions",
  icon: GitBranch,
  type: "sub",
  active: false,
  children: [

    {
      path: `/versions`,
      title: "Versions",
      icon: MessageCircle,
      type: "link",
    },
  ]
},



     

    ],
  },
];
